// import { Control, Controller } from "react-hook-form";
// import { AgendaUser } from "../../graphql/API";
// import { Text, TextInput, View } from "react-native";
// import styles from "./styles";
// import React from "react";
// import { RadioButton } from 'react-native-paper';

// export type IEditableUserField = 'night' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';
// export type IEditableUser = Pick<AgendaUser, IEditableUserField>;

// interface ICustomInput {
//     label: string;
//     multiline?: boolean;
//     control: Control<IEditableUser, object>; // <IUser, object>;
//     name: IEditableUserField; // string;
//     rules?: object;
// };

// const CustomRadio = ({control, name, label, rules = {}, multiline = false}: ICustomInput) => {
//     return (
//         <Controller
//             control={control}
//             name={name}
//             rules={rules} // {{ required: true }}
//             render={({field: {onChange, value, onBlur, name, ref}, fieldState: {invalid, isTouched, isDirty, error}}) => {

//                 return (
//                     <View style={styles.inputRadioSmallContainer}>
//                         <Text style={styles.radioLabel}>{label}</Text>
//                         <View>
//                             <RadioButton
//                                 disabled={false}
//                                 uncheckedColor={'#000'}
//                                 value={value ? 'checked' : 'unchecked'}
//                                 status={ value ? 'checked' : 'unchecked' }
//                                 onPress={() => onChange(!value)} // () => setChecked('first')}
//                             />
//                             {error && <Text style={styles.error}>{error.message || error.type}</Text>}
//                         </View>
//                     </View>
//                 )
//             }}
//         />
//     )
// };

// export default CustomRadio;

import { Control, Controller } from "react-hook-form";
import { AgendaUser } from "../../graphql/API";
import React from "react";

export type IEditableUserField =
  | "night"
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export type IEditableUser = Pick<AgendaUser, IEditableUserField>;

interface ICustomInput {
  label: string;
  control: Control<IEditableUser, object>;
  name: IEditableUserField;
  rules?: object;
}

const styles = {
  inputRadioSmallContainer: {
    marginBottom: "1rem",
  },
  radioLabel: {
    display: "block",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  radioWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  error: {
    color: "red",
    fontSize: "0.875rem",
    marginTop: "0.25rem",
  },
} as const;

const CustomRadio = ({ control, name, label, rules = {} }: ICustomInput) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { onChange, value },
        fieldState: { error },
      }) => (
        <div style={styles.inputRadioSmallContainer}>
          <label style={styles.radioLabel}>{label}</label>
          <div style={styles.radioWrapper}>
            <input
              type="checkbox"
              checked={!!value}
              onChange={() => onChange(!value)}
              id={name}
            />
            <label htmlFor={name}>{value ? "Yes" : "No"}</label>
          </div>
          {error && <div style={styles.error}>{error.message || error.type}</div>}
        </div>
      )}
    />
  );
};

export default CustomRadio;
